import { toRadialAxis, toSpokeAngle } from './radialAxis';
import type { RadialPlot, RadialSeries, RadialSpoke } from './types';

export type SpiderSeriesInput = {
  key: string;
  label: string;
  /** One per spoke, in spoke order. */
  values: (number | null)[];
};

export type SpiderPlotArgs = {
  spokes: { key: string; label: string }[];
  series: SpiderSeriesInput[];
  radialTitle: string;
};

const toSeries = (
  spokes: RadialSpoke[],
  { key, label, values }: SpiderSeriesInput
): RadialSeries => ({
  key,
  label,
  points: spokes.map((spoke, index) => ({
    key: spoke.key,
    label: spoke.label,
    angle: spoke.angle,
    value: values[index] ?? null,
    angleValue: null,
  })),
});

export const toSpiderPlot = ({
  spokes,
  series,
  radialTitle,
}: SpiderPlotArgs): RadialPlot => {
  const placedSpokes = spokes.map((spoke, index) => ({
    ...spoke,
    angle: toSpokeAngle(index, spokes.length),
  }));

  return {
    series: series.map(input => toSeries(placedSpokes, input)),
    angularAxis: { kind: 'categorical', spokes: placedSpokes },
    radialAxis: toRadialAxis(
      series
        .flatMap(({ values }) => values)
        .filter((value): value is number => value !== null)
    ),
    radialTitle,
  };
};
